const styles = (theme) => ({
  paymentLabel: {
    paddingTop: theme.spacing(1),
  },
  paymentValue: {
    color: theme.color.grey_75,
  },
});

export default styles;
